import type { AnalyzeLicense, AnalyzeTab } from "../types";

export const ANALYZE_TABS = Object.freeze({
    OVERVIEW: "overview",
    CONSUMPTION: "consumption",
    METRICS: "metrics",
    OPTIMIZATION: "optimization",
    MEASURES: "measures",
    PORTFOLIO: "portfolio",
    EXPORT: "export",
} as const);

export const DEFAULT_ANALYZE_TAB = ANALYZE_TABS.OVERVIEW;

export const ANALYZE_LICENSES = Object.freeze({
    PREMIUM: "premium",
    ENTERPRISE: "enterprise",
} as const);

// tabs without an entry are part of the base licence and always visible
export const ANALYZE_TAB_LICENSES: Partial<Record<AnalyzeTab, AnalyzeLicense>> =
    Object.freeze({
        [ANALYZE_TABS.OPTIMIZATION]: ANALYZE_LICENSES.PREMIUM,
        [ANALYZE_TABS.MEASURES]: ANALYZE_LICENSES.PREMIUM,
        [ANALYZE_TABS.PORTFOLIO]: ANALYZE_LICENSES.ENTERPRISE,
    });

export const TAB_COUNT_BADGE_TYPES = Object.freeze({
    NEUTRAL: "NEUTRAL",
    TERTIARY: "TERTIARY",
} as const);
